import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Upload } from '@phosphor-icons/react';
import { getToken } from '@/utils/auth';
import { logger } from '@/utils/logger';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const FileImportTab = ({ onGamesUpdated }) => {
  const [loading, setLoading] = useState(false);

  const handleFileUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);

    setLoading(true);
    try {
      const token = getToken();
      const response = await axios.post(`${API}/admin/games/import-file`, formData, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      toast.success(`Imported ${response.data.imported_count} games!`);
      if (response.data.errors?.length > 0) {
        logger.warn('Import errors:', response.data.errors);
      }
      onGamesUpdated?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to import file');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 pt-4">
      <div className="border-2 border-dashed border-[#E4E4E7] p-8 text-center">
        <Upload size={48} className="mx-auto text-[#71717A] mb-4" />
        <p className="text-[#09090B] mb-2">Upload CSV or JSON file</p>
        <p className="text-sm text-[#71717A] mb-4">
          CSV columns: name, image, genre, description, players, platform, developer
        </p>
        <input
          type="file"
          accept=".csv,.json"
          onChange={handleFileUpload}
          className="hidden"
          id="file-upload"
        />
        <label htmlFor="file-upload">
          <Button asChild disabled={loading}>
            <span>{loading ? 'Importing...' : 'Choose File'}</span>
          </Button>
        </label>
      </div>
    </div>
  );
};
